import { Directive, ElementRef, Renderer2, AfterViewInit, OnDestroy, NgZone } from '@angular/core';

@Directive({
  selector: '[appScaleToFit]'
})
export class ScaleToFitDirective implements AfterViewInit, OnDestroy {
  private parent: HTMLElement;
  private resizeObserver: ResizeObserver;

  constructor(private el: ElementRef, private renderer: Renderer2, private ngZone: NgZone) {}

  ngAfterViewInit(): void {
    this.parent = this.el.nativeElement.parentElement;

    if (this.parent) {
      this.setupStyles();
      this.initResizeObserver();
    } else {
      console.warn('ScaleToFitDirective: Element parent not found');
    }
  }

  private setupStyles(): void {
    this.renderer.setStyle(this.parent, 'display', 'flex');
    this.renderer.setStyle(this.parent, 'justify-content', 'center');
    this.renderer.setStyle(this.parent, 'align-items', 'center');
    this.renderer.setStyle(this.parent, 'margin', '0 auto');
    this.renderer.setStyle(this.parent, 'overflow', 'hidden');

    this.renderer.setStyle(this.el.nativeElement, 'transform-origin', '0 0');
    this.renderer.setStyle(this.el.nativeElement, 'will-change', 'transform');
  }

  private initResizeObserver(): void {
    this.ngZone.runOutsideAngular(() => {
      this.resizeObserver = new ResizeObserver(() => {
        this.calculateScale();
      });

      this.resizeObserver.observe(this.parent);
      this.resizeObserver.observe(this.el.nativeElement);
    });

    setTimeout(() => this.calculateScale());
  }

  private calculateScale(): void {
    const parentWidth = this.parent.clientWidth;
    const contentWidth = this.el.nativeElement.scrollWidth;

    if (contentWidth > 0 && parentWidth > 0) {
      const scale = parentWidth / contentWidth;

      this.ngZone.run(() => {
        this.renderer.setStyle(this.el.nativeElement, 'transform', `scale(${scale})`);
      });
    }
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
}
